import React from "react";
import { Route, Routes } from "react-router-dom";

import PrivacyPolicy from "@/components/screens/PrivacyPolicy";
import PRIVACY_POLICY_MESSAGES from "@/messages/privacy/privacy.messages";

const PrivacyPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<PrivacyPolicy messages={PRIVACY_POLICY_MESSAGES} />} />
      <Route path="/" element={<PrivacyPolicy messages={PRIVACY_POLICY_MESSAGES} />} />
    </Routes>
  );
};

export default PrivacyPage;
